import { ValidateProperty } from "../../utilities/validate-property";

export class CreditLineItem {

    @ValidateProperty({ required: true })
    public reasonId: number | undefined = undefined;
    @ValidateProperty({ requiredFn: ( instance: CreditLineItem) =>  instance.disabledCategory ? false : true })
    public categoryId: number | undefined = undefined;
    @ValidateProperty({ required: true })
    public description: string = '';
    @ValidateProperty({ required: true })
    public amount: number = 0.0;

    // UI Helper Properties
    public disabledCategory : boolean = false;
}